<template>
	<el-container style=" border: 1px solid #eee">
		 <el-main>
			<el-table :data="tableData">
			 <el-table-column prop="id" label="ID" width="100">
			 </el-table-column>
			 <el-table-column prop="username" label="用户名" width="120">
			 </el-table-column>
			 <el-table-column prop="nickname" label="昵称" width="140">
			 </el-table-column>
			 <el-table-column prop="age" label="年龄" width="50">	
			 </el-table-column>
			 <el-table-column prop="sex" label="性别" width="50" >
			 </el-table-column>
			 <el-table-column prop="phone" label="电话" width="150" >
			 </el-table-column>
			 <el-table-column prop="address" label="地址" width="200" >
			 </el-table-column>
			 <el-table-column prop="remark" label="个人简介" width="200" >
			</el-table-column>
			 
			  <el-table-column
			       fixed="right"
			       label="操作"
			       width="220">
			       <template slot-scope="scope" >
			         <el-button @click="infodialog = true,show(scope.row)" type="primary" size="small">查看</el-button>
						   <el-dialog
						     title="用户信息"
						     :visible.sync="infodialog"
							 :modal-append-to-body="false"
						     width="50%"
						     :before-close="handleClose">
								<div>用户名：{{info.username}}</div>
							    <el-divider></el-divider>
							 	<div>昵称：{{info.nickname}}</div>			
								<el-divider></el-divider>
								<div>年龄：{{info.age}}</div>
								<el-divider></el-divider>
								<div>性别：{{info.sex}}</div>
								<el-divider></el-divider>
							 	 <div>手机：{{info.phone}}</div>					
								<el-divider></el-divider>		
							 	 <div>地址：{{info.address}}</div>
								 <el-divider></el-divider>
								 <div>个人简介：{{info.remark}}</div>
								 
								 							
							
						   </el-dialog>
			         
					 <el-button type="danger" @click="deleteById(scope.row)" size="small" style="margin-left: 10px;">删除</el-button>
			       </template>
			     </el-table-column>
			</el-table>
		</el-main>
	<el-footer>
		<el-pagination background @current-change="handleCurrentChange":current-page="currentPage":page-size="pagesize"layout="total, prev, pager, next, jumper":total="totalCount">
		</el-pagination>
	</el-footer>
</el-container>
</template>
<style>
	*{
		margin:0;
		padding: 0;
	}
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }
</style>

<script>
import Axios from 'axios'		
  export default {
	data() {
		return{
			dialogVisible: false,
			infodialog: false,
			tableData:[
				
			],
			info:{
				id:1,
				username:"",
				password:"",
				nickname:"",
				age:"",
				sex:"",
				phone:"",
				address:"",
				remark:"",
				
			},
			 pagesize:8,    //    每页的数据
			 currentPage:1,//第几页
			 totalCount:1,//总条数 这些数据虽然后面会赋值为后端返回的数，但是最好不要为空

		}
   },
   created(){
	   this.request.get("/getAllUserInfo",{params:{"page":this.currentPage,"num":this.pagesize}}).then(res => {
	               this.tableData=res.info;
	   				this.totalCount=res.total
	   													
	   				}).catch(error => { console.log(error)})
   },
   methods:{
	       handleCurrentChange(val){
	         this.currentPage=val
	         this.getData(this.pagesize,val)
	       },   
		   getData(n1,n2){
			   this.request.post("/getAllUserInfo",{params:{"page":n2,"num":n1}}).then(res => {
			               this.info=res.info;
						   this.totalCount=res.total
													
				}).catch(error => { console.log(error)})
		   },
		   handleClose(done) {
		          
		               done();
		            
		   },
		   deleteById(e){
			   this.$confirm('确认删除本条用户记录？').then(_=> {this.delete(e.id)}).catch(_=> {});
		   },  
		   delete(i){
			this.request.get('/deleteUserById',{params:{"ID":i}}).then(response => {
				   if(response.code=="0"){
					   this.$message({message: '删除成功',type: 'success'});
					   this.request.get("/getAllUserInfo",{params:{"page":this.currentPage,"num":this.pagesize}}).then(res => {
	               this.tableData=res.info;
	   				this.totalCount=res.total
	   													
	   				}).catch(error => { console.log(error)})
				   }else{
					    this.$message.error('删除失败');
				   }
				   }).catch(error => { console.log(error)})
		   },
		   show(e){
			   this.info=e; 
		   }
		   
   }
  };
</script>
